import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import PlanSelection from '../../../../components-next/enterprise/PlanSelection.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/plan-selection'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'PLAN_SELECTION.TITLE',
        icon: 'credit-card',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'plan_selection_index',
          component: PlanSelection,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
